export const UserProfile = {
    tooltip: {
        selector: '.me-tooltip',
    },
    table: {
      collapseContainerSelector: '.collapse',
      collapseToggleSelector: '.collapse-header td'
    },

    init: function() {
        UserProfile.initializeTooltip();
        UserProfile.initializeTable();
    },

    initializeTooltip: function() {
      if (UserProfile.tooltip.selector.length > 0) {
        $(UserProfile.tooltip.selector).tooltip({
          html: true
        });
      }
    },
    initializeTable: function() {
      const $collapseContainer = $(UserProfile.table.collapseContainerSelector);
      if ($collapseContainer.length > 0) {
        $(UserProfile.table.collapseToggleSelector).on('click', function () {
          const collapseTarget = $(this).parent().attr('data-target');
          $(collapseTarget).collapse('toggle');
        });
      }
    },
};
